module.exports = {
  tag: 'gladiator',
  quality: 0.7,
};
